var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('splide',{attrs:{"options":_vm.options}},_vm._l((_vm.slides),function(slide){return _c('splide-slide',{key:slide},[_c('img',{attrs:{"src":slide.src,"alt":slide.alt}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }